import { Avatar, Button, Divider, Modal, Typography } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useAccountSuspense } from '../../hooks/useAccount';
import { AuthService } from '../../services/auth/auth_service';
import { useState } from 'react';

const { Text, Title } = Typography;

interface ProfileDialogProps {
    open: boolean;
    onClose: () => void;
}

export default function ProfileDialog({ open, onClose }: ProfileDialogProps) {
    const account = useAccountSuspense();
    const [actionLoading, setActionLoading] = useState(false);

    function handleLogout() {
        setActionLoading(true);
        AuthService.getInstance().signOut().finally(() => {
            setActionLoading(false);
            onClose();
        });
    }

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={400}
            centered
        >
            <div style={{ textAlign: 'center' }}>
                {/* Large Avatar */}
                <Avatar
                    size={120}
                    icon={<UserOutlined />}
                />

                {/* Full Name */}
                <Title level={3}>
                    {account && account.data
                        ? `${account.data.firstName} ${account.data.lastName}`
                        : 'Einmal Token Nutzer'}
                </Title>

                {/* Employee Type */}
                <Text type="secondary">
                    {account && account.data ? account.data.email : '---'}
                </Text>
            </div>

            <Divider />

            {/* Action Buttons */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {/* Logout Button */}
                <Button
                    icon={<LogoutOutlined />}
                    onClick={handleLogout}
                    loading={actionLoading}
                    size="large"
                    danger
                    style={{
                        textAlign: 'left',
                        height: 48,
                    }}
                    block
                >
                    Abmelden
                </Button>
            </div>
        </Modal>
    );
}